export function getShoppingRequestEnabledFlag( locale, isLoggedOutDefault, isShoppingReqWGEnabled ){
  const localeArr = locale.split('_');
  const isCartPageToRender =
    (localeArr[1] === 'US' || localeArr[1] === 'CA') &&
    window?.flags['GNA-10394-SHOPPING-CART'] &&
    isShoppingReqWGEnabled

  const isShoppingCartEnabled = isLoggedOutDefault || isCartPageToRender

  return isShoppingCartEnabled
}
